export const TASK_STATUSES = {
  RESPONSE_RECEIVED: '5a1e7d8ff7c5f4ebba3f503c',
  PROVIDER_HOLD: '5a1ba9b0f7c5f4ebba017f25',
}
